var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgW2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 63,
    viewBox: "0 0 57 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5627 31.5738L25.1877 38.1958L38.4377 24.9518M55.0002 31.5738C55.0002 46.3445 36.914 57.0477 30.6249 60.3232C29.9448 60.6775 29.6046 60.8546 29.1329 60.9464C28.7652 61.0179 28.2352 61.0179 27.8676 60.9464C27.3959 60.8546 27.0557 60.6775 26.3756 60.3232C20.0864 57.0477 2.00024 46.3445 2.00024 31.5738V19.0503C2.00024 16.4031 2.00024 15.0795 2.43339 13.9418C2.81601 12.9367 3.4378 12.0399 4.24499 11.3288C5.15871 10.5239 6.39858 10.0592 8.87832 9.12972L26.6393 2.4724C27.328 2.21427 27.6721 2.08521 28.0266 2.03402C28.3406 1.98866 28.6599 1.98866 28.9739 2.03402C29.3284 2.08521 29.6725 2.21427 30.3612 2.4724L48.1222 9.12972C50.6019 10.0592 51.8418 10.5239 52.7554 11.3288C53.5626 12.0399 54.1844 12.9367 54.567 13.9418C55.0002 15.0795 55.0002 16.4031 55.0002 19.0503V31.5738Z",
    stroke: "#0F4BFF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgW2);
export default __webpack_public_path__ + "static/media/w-2.3bdd83373f08d90e7ecd2fd1fde1f99e.svg";
export { ForwardRef as ReactComponent };